import React from 'react'
import Icon from '@ant-design/icons';

export default (props) => {
  const {
    color, // цвет знака

    width,
    height,

    style: {
      width: style_width,
      height: style_height,
      color: style_color,
    } = {},
    ...rest
  } = props;

  const fill_color = color || style_color || '#FF7A24';

  const w = width || style_width || 24;
  const h = height || style_height || 23;

  const SvgIcon = () => (
    <svg
      width={w}
      height={h}
      viewBox={`0 0 ${w} ${h}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0247 7.37257H8.97535C8.68288 7.37257 8.4024 7.48875 8.19559 7.69555C7.98879 7.90236 7.87261 8.18285 7.87261 8.47531V14.5246C7.87261 14.8171 7.98879 15.0976 8.19559 15.3044C8.4024 15.5112 8.68288 15.6274 8.97535 15.6274H15.0247C15.3171 15.6274 15.5976 15.5112 15.8044 15.3044C16.0112 15.0976 16.1274 14.8171 16.1274 14.5246V8.47531C16.1274 8.18285 16.0112 7.90236 15.8044 7.69555C15.5976 7.48875 15.3171 7.37257 15.0247 7.37257Z"
        fill={fill_color}
      />
      <path
        d="M12 0C9.72552 0 7.50211 0.674463 5.61095 1.9381C3.71978 3.20174 2.2458 4.99779 1.37539 7.09914C0.504983 9.20049 0.277244 11.5128 0.720974 13.7435C1.1647 15.9743 2.25997 18.0234 3.86828 19.6317C5.47658 21.24 7.52568 22.3353 9.75646 22.779C11.9872 23.2228 14.2995 22.995 16.4009 22.1246C18.5022 21.2542 20.2983 19.7802 21.5619 17.8891C22.8255 15.9979 23.5 13.7745 23.5 11.5C23.4967 8.45103 22.284 5.5279 20.128 3.37196C17.9721 1.21601 15.049 0.00333585 12 0ZM12 20.7945C10.1617 20.7945 8.36472 20.2494 6.83625 19.2281C5.30777 18.2068 4.11647 16.7552 3.41299 15.0569C2.70951 13.3585 2.52544 11.4897 2.88408 9.68673C3.24271 7.88377 4.12792 6.22764 5.42779 4.92778C6.72765 3.62792 8.38377 2.7427 10.1867 2.38407C11.9897 2.02544 13.8585 2.2095 15.5569 2.91298C17.2552 3.61646 18.7068 4.80776 19.7281 6.33624C20.7494 7.86472 21.2945 9.66171 21.2945 11.5C21.292 13.9643 20.312 16.3269 18.5695 18.0695C16.8269 19.812 14.4643 20.792 12 20.7945Z"
        fill={fill_color}
      />
    </svg>
  );

  return <Icon component={SvgIcon} {...rest} />;
}
